import React, { useState, useEffect } from 'react';
import { Popover } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ButtonStyled from './ButtonStyled';
import IconButtonStyled from './IconButtonStyled';

const useStyles = makeStyles((theme) => ({
    popoverClass: {
        // Ajouter styles ici si nécessaire
    },
}));
const ButtonConfirm = ({ onConfirm, text, textConfirm, variant, color, style, icon, position }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const openPop = Boolean(anchorEl);

    const handleClickPop = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClosePop = () => {
        setAnchorEl(null);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (anchorEl && !anchorEl.contains(event.target)) {
                handleClosePop();
            }
        };

        if (openPop) {
            document.addEventListener('click', handleClickOutside);
        }

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [anchorEl, openPop]);

    return (
        <>
           {icon ? (
                <IconButtonStyled color={color} style={style} onClick={handleClickPop} tooltipTitle={text} position={position}>
                    {icon}
                </IconButtonStyled>
            ) : (
                <ButtonStyled variant={variant} color={color} style={style} onClick={handleClickPop}>
                    {text}
                </ButtonStyled>
            )}
            <Popover
                open={openPop}
                anchorEl={anchorEl}
                onClose={handleClosePop}
                className={classes.popoverClass}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                disableEnforceFocus
            >
                <ButtonStyled
                    variant="contained"
                    color="errorBtn"
                    onClick={() => {
                        onConfirm();
                        handleClosePop();
                    }}
                >
                    {textConfirm}
                </ButtonStyled>
            </Popover>
        </>
    );
};

export default ButtonConfirm;
